import { isElementWithinRef } from './isElementWithinRef';
export const getSharedFooterProps = _ref => {
  let {
    id,
    refToFocusOnClear,
    closeMenu,
    reset
  } = _ref;
  const onBlur = event => {
    // If we're focusing on the target (control), don't close the dropdown
    // If we aren't focusing the control, we're probably tabbing to the next component
    // So we should close the menu
    if (isElementWithinRef({
      ref: refToFocusOnClear,
      element: event.relatedTarget
    })) {
      return;
    }
    closeMenu();
  };
  const onClear = () => {
    reset();
    refToFocusOnClear.current.focus();
  };
  const onMouseDown = event => {
    // Prevent the menu from closing when anything is clicked in the footer
    event.preventDefault();
  };
  return {
    onBlur,
    onClear,
    onMouseDown,
    id: "".concat(id, "-dropdown-footer"),
    ['data-testid']: 'dropdown-footer'
  };
};
//# sourceMappingURL=sharedFooterLogic.js.map